
import { Card, Col, Divider, Form, Input, Row, Space,Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast,loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useUserRepo from "../../../services/repo/useUserRepo";
import useOrgRepo from "../../../services/repo/useOrgRepo";

export default function User() {

    useTopbarTitleHooks("User");
    const { isLoading: isLoadingList, getUserList } = useUserRepo(false)
    const { isLoading: isLoadingDelete,  deleteUser} = useUserRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)


    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        userId: "",
        userFirstName: "",
        userLastName: "",
        userFullName:"",
        userEmail:"",
        orgId: null,
        orgName:"",
        status: "true"
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "userFirstName",
        isAscending: true
    });

    const onSearch = (value) => {
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const fetchData = async () => {
      
        const payload = {
            ...tableParams
        }
        const res = await getUserList(payload)
        if (res?.detail=='OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.user.create);
    }

    const handleEdit = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.userManagement.user.edit(data?.userId));
        dismissToast(key)
    }

   const handleDelete = async (record) => {
        const key = 'deleteUser';
        try {

          debugger
        
          loadingToastId(Constant.message.loading, key)
      
          const response = await deleteUser({ userId: record.userId });
      
          if (response?.status === 200 && response?.detail === 'OK') {
            successToast(Constant.message.deleteDataSuccess);
            fetchData(); 
          } else {
            errorToast(Constant.message.deleteDataFail);
          }
        } catch (error) {
          console.error('Error:', error);
          errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); 
          }
    };

    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditUser);
    }


    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail=='OK' && res?.status === 200) {
            setOrgOptions(() => {
                return res?.data?.content.map(item => {
                    return { label: item?.orgName, value: item?.orgId }
                })
            })
        }
    }
    
    

    useEffect(() => {
        fetchCheckPrivilege()
    }, [])

    useEffect(() => {
        if (isLoadedPrivilege) {
            fetchData();
        }
        fetchDataOrg();
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => {
        return (
            <Form layout="horizontal" form={form}>
                <Row gutter={16}>
                    <Col xs={24} sm={10} md={8}>
                        <Form.Item name='userFirstNameFilter' label="Filter By">
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterFirstName}
                                onChange={(e) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        userFirstName: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={10} md={7}>
                        <Form.Item name='emailFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterEmail}
                                onChange={e => {
                                    setFilters(prev => ({
                                        ...prev,
                                        userEmail: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={8} md={6}>
                        <Form.Item name='orgFilter'>
                        <Select
                            style={{ width: '100%' }}
                            allowClear
                            placeholder='Select Organization'
                            loading={isLoadingOrgList}
                            options={orgOptions}
                            onChange={value => {
                            setFilters(prev => ({
                                ...prev,
                                orgId: value
                            }))
                            }}
                        />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "60px",
            render: (_, record) => {
                const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        // {
        //     title: 'First Name',
        //     dataIndex: 'userFirstName',
        //     sorter: true,
        //     width: "150px",
        //     render: (data) => <CellTable data={data} />
        // },
        // {
        //     title: 'Last Name',
        //     dataIndex: 'userLastName',
        //     sorter: true,
        //     width: "150px",
        //     render: (data) => <CellTable data={data} />
        // },
        {
            title: 'Full Name',
            dataIndex: 'userFullName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Email',
            sorter: true,
            dataIndex: 'userEmail',
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Organization',
            dataIndex: 'orgName',
            sorter: true,
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "100px",
            render: (data) => <CellTable data={data === "true" ? "Active" : "Inactive"} />
        }
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"userId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingList}
                                    onChange={handleTableChange}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }

          

            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
